import styled from "styled-components";

export const FormContainer = styled.div`
  padding-top: 50;
  background: #f8f8f9;
  padding-bottom: 220px;
  div {
    form {
      padding-top: 50px;
      margin: auto;
      min-width: 250px;
      max-width: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .term{
        width: 100%;
        display: flex;
        flex-direction: row;
        margin-left: 100px;
        margin-top: 40px;

        & + .term{
        margin-top: 0px;
        margin-bottom: 40px;

        }

        #termos{
          margin-top: 2px;
        }

        .lblTermos{
          font-size: 11px;
          margin-bottom: 0px;
          margin-left: 10px;
        
          .link{
            color: #589bff;
            cursor: pointer;
          }
        }
      }

      button {
        margin: 15px;
        width: 100%;
        max-width: 400px;
        height: 60px;
        i {
          margin-left: 15px;
        }
      }
    
    }
  }

  @media only screen and (max-width: 991px){
    div{
      form{
        .term{
          margin-left: 32px !important;
        }
      }
    }
  }
  

`;

export const InfoCardPrevStepOne = styled.div`
  :hover{
    background-color: #FFF;
    margin-top: -135px;
  }
  width: 285px;
  background: #f8f8f8f8;
  box-shadow: 0 0 10px 10px rgba(29, 33, 41, 0.1);
  border-radius: 30px;
  cursor: pointer;
  margin-right: -285px;
  margin-top: -115px;
  transition: margin-top 0.5s;

  h1 {
    font-size: 20px;
    color: #303848;
    margin-left: 27px;
    margin-top: 10px;
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: collumn;
  margin-top: 130px;
`;

export const Valores = styled.div`
  padding: 12px;
  font-size: 16px;
  text-align: center;
  width: 400px;

  .sublinhado{
    text-decoration: line-through
  }

  .desconto{
    color: red;
  }

  .direita{
    text-align: right;
  }

  .resultado{
    font-size: 20px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;
  }

  th, td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  th {
    background-color: #f2f2f2;
  }

  @media only screen and (max-width: 768px){
    width: 100%;
  }
`;

export const InfoCardPrevStepTwo = styled.div`
  :hover{
    background-color: #FFF;
    margin-top: -87px;
  }
  width: 285px;
  background: #f8f8f8f8;
  box-shadow: 0 0 10px 10px rgba(29, 33, 41, 0.1);
  border-radius: 30px;
  cursor: pointer;
  margin-top: -67px;
  margin-right: -285px;
  transition: margin-top 0.5s;

  h1 {
    font-size: 20px;
    color: #303848;
    margin-left: 27px;
    margin-top: 10px;
  }
`;

export const InfoCard = styled.div`
  width: 285px;
  height: auto;
  background: #fff;
  box-shadow: 0 0 10px 10px rgba(29, 33, 41, 0.1);
  border-radius: 30px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: 30px;
  justify-content: space-around;
  h1 {
    font-size: 24px;
    color: #303848;
  }
  .item {
    p {
      color: #303848;
      font-size: 14px;
      font-weight: 700;
    }
    .icon-wrapper {
      display: flex;
      align-items: center;
      i {
        margin-right: 7px;
        color: #bbb;
        margin-left: -5px;
      }
    }
    small {
      font-size: 11px;
      color: #bac1cf;
      font-weight: 700;
    }
  }
`;

export const InfoCardWrapper = styled.div`
  margin-top: 0px;
  width: 100%;
  display: ${props =>
    props.show === "sm" ? "none" : props.show === "xs" ? "none" : "flex"};
  justify-content: center;
  align-items: center;
`;
